import { useState } from 'react'

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '', email: '', subject: '', message: ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    alert('Message sent! We\'ll get back to you soon ✨')
    console.log(formData)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-12">
          Get In Touch
        </h1>

        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-6">We'd love to hear from you</h2>
            <div className="space-y-6">
              <div><p className="font-semibold">Email</p><p className="text-gray-600">hello@yourcompany.com</p></div>
              <div><p className="font-semibold">Phone</p><p className="text-gray-600">+1 (555) 123-4567</p></div>
              <div><p className="font-semibold">Address</p><p className="text-gray-600">123 Tech Street<br />San Francisco, CA 94105</p></div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <input placeholder="Your Name" name="name" required onChange={handleChange} className="px-4 py-3 border rounded-lg" />
              <input placeholder="Your Email" type="email" name="email" required onChange={handleChange} className="px-4 py-3 border rounded-lg" />
            </div>
            <input placeholder="Subject" name="subject" required onChange={handleChange} className="w-full px-4 py-3 border rounded-lg" />
            <textarea placeholder="Your message..." name="message" rows={6} required onChange={handleChange} className="w-full px-4 py-3 border rounded-lg"></textarea>
            <button type="submit" className="w-full bg-indigo-600 text-white py-4 rounded-lg font-semibold hover:bg-indigo-700 transition">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}